export default {
      id: "oc-menu-iam-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-menu-iam",
      toString: function () {
        return this.url;
      }
    }